import { SubscriptionCFA } from '@/account/types/subscription';

export default function useCanOrder(subscription: SubscriptionCFA | undefined) {
  return (
    !subscription ||
    (subscription.has_vehicle && subscription.can_return && subscription.can_swap)
  );
}
